
import type { Container } from 'vue-di';

export class EntLibServiceClient {
    public static isEntLibServiceClient = true as const;
}


export type KnownEntLibEnvironments = 'qa' | 'uat' | 'training' | 'lab' | 'prod';



export interface ConfigureFunction {
    (container: Container, basePath?: KnownEntLibEnvironments): void;
    (container: Container, basePath: string, audience: string): void;
}

export interface IHasConfigureFunction {
    configure?: ConfigureFunction;
}

export interface IConstructorHasConfigureFunction {
    constructor: IHasConfigureFunction;
}

export type IConfigurableEntLibServiceClient = IConstructorHasConfigureFunction & EntLibServiceClient;


export interface IHasPackageName {
    packageName?: string;
}

export interface IConstructorHasPackageName {
    constructor: IHasPackageName;
}

export type IEntLibServiceClientWithPackageName = IConstructorHasPackageName & EntLibServiceClient;

export type EntLibServiceClientClass = IConfigurableEntLibServiceClient['constructor'] & IEntLibServiceClientWithPackageName['constructor'];

/**
 * Adds a reference to the configure function to the class's metadata.
 *
 * @param {ConfigureFunction} value Reference to the npm package's configure function.
 */
export function ConfigureWith(value: ConfigureFunction) {
    return <T extends EntLibServiceClientClass>(target: T) => {
        target.configure = value;

        return target as T & Required<IHasConfigureFunction>;
    }
}


export function SetPackageName(value: string) {
    return <T extends EntLibServiceClientClass>(target: T) => {
        target.packageName = value;

        return target as T & Required<IHasPackageName>;
    }
}